export const TABLES_TENDER_UMUM = "TABLES_TENDER_UMUM";
export const RESET_TABLES_TENDER_UMUM = "RESET_TABLES_TENDER_UMUM";
export const DETAILS_TENDER_UMUM = "DETAILS_TENDER_UMUM";
export const RESET_DETAILS_TENDER_UMUM = "RESET_DETAILS_TENDER_UMUM";